module.exports = __webpack_public_path__ + "static/0038-3d050bd8dd502aab2c27482f7e4c7527.png";